<template>
  <div class="swiper hotelSwiper swiper-no-swiping">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in hotelData"
          :key="index"
          class="swiper-slide"
        >
          <div class="hotelBox">
            <img alt="" :src="item.img" class="hotelImg"/>
            <div class="hotelContent">
              <div style="font-weight: 600;width: 150px;text-align: left;" class="zhunyuan">{{item.title}}</div>
              <div class="fontBox">
                <div style="margin-right:10px;">
                  <span class="small">￥</span>
                  <span class="big">{{item.price}}</span>
                  <span class="small"> 起</span>
                </div>
                <a href="javascript:void(0)" @click="goBook(item.link)" class="bookingBtn zhunyuan">立即预定</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["audioPlayStatus"],
  data() {
    return {
      hotelData: [
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/1.jpg",
          title: "济州套房酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seogwipo_1549&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "795"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/2.jpg",
          title: "济州岛新罗酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seogwipo_832&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "2567"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/3.jpg",
          title: "安达仕首尔江南酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_5741&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1397"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/4.jpg",
          title: "格兰德华克山庄首尔大酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_4273&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "941"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/5.jpg",
          title: "明洞PJ酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_185&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "342"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/6.jpg",
          title: "首尔东大门诺富特大使酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_2929&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "721"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/7.jpg",
          title: "首尔大使铂尔曼酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_4424&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1314"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/8.jpg",
          title: "首尔明洞朝鲜福朋喜来登酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_8078&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "434"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/9.jpg",
          title: "首尔威斯汀朝鲜酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_622&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1010"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/10.jpg",
          title: "首尔东大门广场JW万豪酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_749&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1337"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/11.jpg",
          title: "首尔新罗酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_765&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1486"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/12.jpg",
          title: "首尔江南大使诺富特酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_4158&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "752"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/13.jpg",
          title: "首尔世贸中心奥卓豪景酒店公寓",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_2012&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1240"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/14.jpg",
          title: "维斯塔华克山庄首尔酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_4249&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1491"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/15.jpg",
          title: "首尔世贸中心洲际酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_4235&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "900"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel_more/16.jpg",
          title: "首尔柏悦酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_4169&checkInDate=2022-03-07&checkOutDate=2022-03-08",
          price: "1933"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel/1.jpg",
          title: "首尔格兰洲际酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_2108&checkInDate=2022-02-14&checkOutDate=2022-02-15",
          price: "1500"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel/2.jpg",
          title: "首尔四季酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-seoul_1437&checkInDate=2022-02-14&checkOutDate=2022-02-15",
          price: "1500"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel/3.jpg",
          title: "釜山柏悦酒店",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-busan_737&checkInDate=2022-02-14&checkOutDate=2022-02-15",
          price: "1500"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel/4.jpg",
          title: "琥珀济州岛度假村",
          link: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&type=0&seq=i-jeju_857&checkInDate=2022-02-14&checkOutDate=2022-02-15",
          price: "1500"
        },
      ],
      swiperList: {
        swiper4: null,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperList.swiper4 = new Swiper(".hotelSwiper .swiper-container", {
        loop: true, // 循环模式选项
        autoplay:true,
        direction: 'vertical',
        slidesPerView: 2,
        slidesPerGroup : 1,
        spaceBetween : 6,
      });
    });
  },
  methods: {
    goBook(url){
      console.log('audioPlayStatus',this.audioPlayStatus)
      sessionStorage.setItem('audioPlayStatus',this.audioPlayStatus);//存储页码
      window.location.href = url;
      return false;
    },
  },
};
</script>
<style lang='less' scoped='true'>
@font-face {
  font-family: "zhunyuan";
  src: url("https://source.qunarzz.com/site/images/wns/zhunyuan.TTF");
}
.zhunyuan{
  font-family: 'zhunyuan';
}
.hotelSwiper .swiper-container {
  height: 480px;
}
.hotelBox{
  border-radius: 4px;
  overflow: hidden;
  // margin-top: 6px;
  font-family: 'FZY4JW';
  // height: 230px!important;
}

.hotelContent{
  display: flex;
  width: 337px;
  height: 58px;
  align-items: center;
  padding: 15px 12px;
  box-sizing: border-box;
  justify-content: space-between;
  background: #fff;
}

.hotelImg{
  width: 337px;
  height: 168px;
  vertical-align: middle;
}

.bookingBtn{
  display: inline-block;
  padding: 8px 11px;
  background: #FF7F28;
  border-radius: 16px;
  color: #fff;
  text-decoration:none;
  font-size: 10px;
}

.fontBox{
  display: flex;
    align-items: center;
}

.small{
    font-weight: 600;
}

.big{
    font-size: 18px;
    font-weight: 600;
}
</style>